import type { JSX } from '@builder.io/qwik';
import { component$, useContext } from '@builder.io/qwik';
import { AppDataContext } from '~/contexts/AppDataContext';
import { cva } from 'class-variance-authority';
import {
  getCSSColorText,
  getCSSSizeLgText,
  getCSSSizeMdText,
  getCSSSizeSmText,
} from '~/utilities/getCSS';
import { getFontSizeObject } from '~/utilities/getFontSizeObject';
import { ArticleContext } from '~/contexts/ArticleContext';
import Image from '~/components/Shared/Image/Image';

const cssClasses = cva('ml-1 pb-2 mt-4 md:m-3', {
  variants: {
    color: getCSSColorText(),
    sizeSm: getCSSSizeSmText(),
    sizeMd: getCSSSizeMdText(),
    sizeLg: getCSSSizeLgText(),
  },
});

export default component$((): JSX.Element => {
  const {
    themeComponents: { image },
  } = useContext(AppDataContext);
  const article = useContext(ArticleContext);
  const { alt, aspectRatio, path, caption, credit, cropping, fileExtension } =
    article.cover.image.value;
  // default cover image sizes
  const imageWidths = { small: 360, medium: 720, large: 1080 };

  return (
    <Image
      alt={alt}
      aspectRatio={aspectRatio}
      path={path}
      caption={caption}
      credit={credit}
      cropping={cropping}
      fileExtension={fileExtension}
      captionClass={cssClasses({
        color: image.textColor.value,
        ...getFontSizeObject(image, 'fontSize'),
      })}
      imageWidths={imageWidths}
      loading='eager'
    />
  );
});
